import { PAYMENTS_API_URL } from 'data/constants';

export async function retryPaymentPostProcessing(depositId: string) {
  const result = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}/retry_post_processing`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to retry payment post processing: ${responseBody}`);
  }
}
